module.exports = __webpack_public_path__ + "img/stena24.e243d621.jpg";